// Lesson Sparks Actions
export const GET_LESSON_SPARK_REQUEST = 'GET_LESSON_SPARK_REQUEST';
export const GET_LESSON_SPARK_SUCCESS = 'GET_LESSON_SPARK_SUCCESS';
export const GET_LESSON_SPARK_FAILURE = 'GET_LESSON_SPARKS_FAILURE';
